import React from 'react';

const WinnerApprovalStatus = ({status}) => {
    let content = (
        <span className="text-warning">
            <i className="fa fa-fw fa-question"></i>
            {window.__js_bid_reviews.pending}
        </span>
    );

    switch (status) {
        case false:
            content = (
                <span className="text-danger">
                    <i className="fa fa-fw fa-times"></i>
                    {window.__js_bid_reviews.discarded}
                </span>
            );
            break;
        case true:
            content = (
                <span className="text-success">
                    <i className="fa fa-fw fa-check"></i>
                    {window.__js_bid_reviews.approved}
                </span>
            );
            break;
    }

    return (
        <span className="text-bold">
            {content}
        </span>
    );
}

export default WinnerApprovalStatus;